import { render, staticRenderFns } from "./ChangeRoleModal.vue?vue&type=template&id=25ee16d6&scoped=true"
import script from "./ChangeRoleModal.vue?vue&type=script&lang=ts"
export * from "./ChangeRoleModal.vue?vue&type=script&lang=ts"
import style0 from "./ChangeRoleModal.vue?vue&type=style&index=0&id=25ee16d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ee16d6",
  null
  
)

export default component.exports